<template>
  <vue-qrcode :value="value" :margin="margin" :scale="scale" />
</template>
<script>
import VueQrcode from 'vue-qrcode';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    scale: {
      type: Number,
      default: 4,
    },
    margin: {
      type: Number,
      default: 4,
    },
  },
  components: {
    VueQrcode,
  },
};
</script>
